import { ITableConfig, ITableRowConfig } from 'components/Table/types';

export const SUPPLIERS_PER_PAGE = 12;

const rowConfigs: ITableRowConfig[] = [
  { header: 'Company Name', flexValue: 1 },
  { header: 'Reference Number', flexValue: 2 },
];

export const tableConfig: ITableConfig = {
  rowConfigs: rowConfigs,
  extraActionsFlexValue: 0.5,
};
